import React from 'react';
import { Database, Puzzle, Scissors } from 'lucide-react';
export function ProductReveal() {
  return <section className="py-10 md:py-16 px-4 bg-[#0a0a0a] relative overflow-hidden" data-id="element-163">
      {/* Background texture */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#cc2200] opacity-5 blur-[100px] rounded-full" data-id="element-164"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-165">
        <div className="text-center mb-8" data-id="element-166">
          <div className="stamp-text text-2xl mb-6 transform rotate-[-5deg] inline-block" data-id="element-167">
            ACCESO CLASIFICADO
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#e5e5e5] mb-6 font-['Special_Elite']" data-id="element-168">
            Te presentamos el Pack 4x1: <br data-id="element-169" />
            <span className="text-[#c8b89a]" data-id="element-170">Colección Investigador Jefe</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-171">
            Esto no es un juego de tablero con dados y fichas de colores. No hay
            casillas de "salida". Lo que vas a recibir son 4 expedientes de
            investigación digital diseñados para que sientas la textura del
            peligro y la adrenalina de la deducción pura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-172">
          {/* Metaphor 1 */}
          <div className="bg-[#1a1a1a] border border-[#333] p-8 rounded-sm relative group hover:border-[#c8b89a] transition-colors duration-300" data-id="element-173">
            <Database className="w-8 h-8 text-[#c8b89a] mb-4" data-id="element-174" />
            <blockquote className="text-gray-300 italic font-mono text-sm leading-relaxed" data-id="element-175">
              "Es como tener acceso a la base de datos secreta de la policía
              mientras el comisario está de vacaciones."
            </blockquote>
          </div>

          {/* Metaphor 2 */}
          <div className="bg-[#1a1a1a] border border-[#333] p-8 rounded-sm relative group hover:border-[#c8b89a] transition-colors duration-300" data-id="element-176">
            <Puzzle className="w-8 h-8 text-[#c8b89a] mb-4" data-id="element-177" />
            <blockquote className="text-gray-300 italic font-mono text-sm leading-relaxed" data-id="element-178">
              "Es un rompecabezas de cristal: cada pista es un fragmento afilado
              que, al unirse, muestra el rostro del asesino."
            </blockquote>
          </div>

          {/* Metaphor 3 */}
          <div className="bg-[#1a1a1a] border border-[#333] p-8 rounded-sm relative group hover:border-[#c8b89a] transition-colors duration-300" data-id="element-179">
            <Scissors className="w-8 h-8 text-[#c8b89a] mb-4" data-id="element-180" />
            <blockquote className="text-gray-300 italic font-mono text-sm leading-relaxed" data-id="element-181">
              "Navegar por estos archivos es como ser un cirujano de la verdad;
              tienes que cortar las mentiras para encontrar el culpable."
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}